import type { ManifestV2 } from './manifest.types';

/**
 * 두 ManifestV2 의 collections 를 합친 새 ManifestV2 를 반환.
 * 첫 인자(client)가 키 충돌 시 우선. 시더가 client 버전(레코드 sheetPins)과
 * server 버전(시딩)을 한 객체로 다루기 위해 사용.
 */
export function mergeManifestCollections(client: ManifestV2, server: ManifestV2): ManifestV2 {
  return {
    ...client,
    collections: { ...server.collections, ...client.collections },
  };
}
